import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { View, Image, TextInput } from 'react-native';
import { getLoanOfferWidgetStyles } from './LoanOfferWidgetStyles';
import { BLACK_300, BLACK_700, BLACK_900, BLUE_500, Callout, Divider, getTestId, InfoTag, isValidObject, LILAC_400, LinkListItem, Slider, StateConfigContext, Typography, useBreakpoint } from '@airtel/air-design-system';
import { TableWidget } from '../table-widget';
import { formatAmountWithCommas } from './LoanOfferWidgetUtils';
export var LoanOfferWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'LoanOfferWidget' : _props$testID,
    id = props.id,
    style = props.style,
    imageUrl = props.imageUrl,
    heading = props.heading,
    subHeading = props.subHeading,
    title = props.title,
    subTitle = props.subTitle,
    _props$showInputAmoun = props.showInputAmount,
    showInputAmount = _props$showInputAmoun === void 0 ? false : _props$showInputAmoun,
    _props$defaultAmount = props.defaultAmount,
    defaultAmount = _props$defaultAmount === void 0 ? '' : _props$defaultAmount,
    _props$isAmountEditab = props.isAmountEditable,
    isAmountEditable = _props$isAmountEditab === void 0 ? false : _props$isAmountEditab,
    amountTextProps = props.amountTextProps,
    textColor = props.textColor,
    onChangeTextMetaData = props.onChangeTextMetaData,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? false : _props$showDivider,
    _props$showBadge = props.showBadge,
    showBadge = _props$showBadge === void 0 ? false : _props$showBadge,
    badgeHeading = props.badgeHeading,
    _props$showBadgeInfoI = props.showBadgeInfoIcon,
    showBadgeInfoIcon = _props$showBadgeInfoI === void 0 ? false : _props$showBadgeInfoI,
    infoIconProps = props.infoIconProps,
    _props$showInfoTag = props.showInfoTag,
    showInfoTag = _props$showInfoTag === void 0 ? false : _props$showInfoTag,
    infoTagProps = props.infoTagProps,
    _props$showSlider = props.showSlider,
    showSlider = _props$showSlider === void 0 ? false : _props$showSlider,
    sliderProps = props.sliderProps,
    _props$minValue = props.minValue,
    minValue = _props$minValue === void 0 ? 0 : _props$minValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? 1 : _props$maxValue,
    onSliderChangeMetaData = props.onSliderChangeMetaData,
    _props$showCallout = props.showCallout,
    showCallout = _props$showCallout === void 0 ? false : _props$showCallout,
    calloutProps = props.calloutProps,
    _props$showTableDivid = props.showTableDivider,
    showTableDivider = _props$showTableDivid === void 0 ? false : _props$showTableDivid,
    _props$showTable = props.showTable,
    showTable = _props$showTable === void 0 ? false : _props$showTable,
    tableItemsProp = props.tableItemsProp,
    onUserAction = props.onUserAction;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true,
      allowMdAsLargeScreen: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var loanOfferWidgetStyles = getLoanOfferWidgetStyles(Object.assign(Object.assign({}, props), {
    theme
  }));
  var _useState = useState('₹' + formatAmountWithCommas(defaultAmount === null || defaultAmount === void 0 ? void 0 : defaultAmount.toString())),
    amount = _useState[0],
    setAmount = _useState[1];
  useEffect(() => {
    setAmount('₹' + formatAmountWithCommas(defaultAmount === null || defaultAmount === void 0 ? void 0 : defaultAmount.toString()));
  }, [defaultAmount]);
  var handleTextInput = text => {
    var actualVal = text === null || text === void 0 ? void 0 : text.replace(/[₹,]/g, '');
    if (isNaN(Number(actualVal))) return;
    setAmount('₹' + formatAmountWithCommas(actualVal));
    onChangeTextMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChangeTextMetaData), {
      value: actualVal
    }));
  };
  return _jsx(_Fragment, {
    children: _jsxs(View, Object.assign({}, getTestId(testID), {
      style: [loanOfferWidgetStyles.container, style]
    }, {
      children: [!!imageUrl && _jsx(Image, {
        resizeMode: "contain",
        source: {
          uri: imageUrl,
          width: isSmallScreen ? 96 : 136,
          height: isSmallScreen ? 96 : 136
        },
        style: loanOfferWidgetStyles.imageUrl
      }), !!heading && _jsx(Typography, {
        text: heading,
        color: BLACK_900,
        type: 'body-single-line-lg-bold',
        style: loanOfferWidgetStyles.heading
      }), !!subHeading && _jsx(Typography, {
        text: subHeading,
        color: BLACK_700,
        type: 'body-single-line-md',
        style: loanOfferWidgetStyles.subHeading
      }), !!title && _jsx(Typography, {
        text: title,
        color: BLACK_700,
        type: 'body-single-line-sm',
        style: loanOfferWidgetStyles.title
      }), !!showInputAmount && _jsx(TextInput, Object.assign({
        style: [loanOfferWidgetStyles.amountStyle, {
          color: textColor
        }],
        cursorColor: BLUE_500,
        keyboardType: "numeric",
        inputMode: "numeric",
        value: amount,
        onChangeText: text => {
          handleTextInput(text);
        },
        placeholderTextColor: BLACK_300,
        editable: isAmountEditable
      }, amountTextProps, getTestId(testID, 'textInput'))), !!showDivider && _jsx(Divider, {
        style: loanOfferWidgetStyles.dividerStyle,
        height: 2,
        color: LILAC_400
      }), !!subTitle && _jsx(Typography, {
        text: subTitle,
        color: BLACK_700,
        type: 'body-single-line-sm',
        style: loanOfferWidgetStyles.subTitle
      }), !!showBadge && _jsx(LinkListItem, {
        style: loanOfferWidgetStyles.badgeStyle,
        heading: badgeHeading,
        showInfoIcon: showBadgeInfoIcon,
        infoIconTooltipProps: infoIconProps
      }), !!showInfoTag && isValidObject(infoTagProps) && _jsx(InfoTag, Object.assign({
        style: loanOfferWidgetStyles.infoTagStyle
      }, infoTagProps)), !!showSlider && isValidObject(sliderProps) && _jsx(Slider, Object.assign({
        style: loanOfferWidgetStyles.sliderStyle,
        minimumValue: minValue,
        maximumValue: maxValue
      }, sliderProps, {
        onValueChange: value => {
          value = minValue + value * (maxValue - minValue);
          onSliderChangeMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onSliderChangeMetaData), {
            value
          }));
        }
      }, getTestId(testID, 'sliderInput'))), !!showCallout && isValidObject(calloutProps) && _jsx(Callout, Object.assign({
        style: loanOfferWidgetStyles.calloutStyle
      }, calloutProps)), !!showTableDivider && _jsx(Divider, {
        style: loanOfferWidgetStyles.tableDividerStyle,
        height: 2,
        color: LILAC_400
      }), !!showTable && isValidObject(tableItemsProp) && _jsx(TableWidget, Object.assign({
        style: loanOfferWidgetStyles.tableStyle
      }, tableItemsProp))]
    }))
  });
};
LoanOfferWidgetComponent.genericRendererKey = 'AirLoanOfferWidget';